import React from "react"
import { Link } from "gatsby"
import * as lang from "../../../languages"
import PropTypes from "prop-types"

 const AppLink = ((props) => {
  const {to, pageContext, ...newProps} = props

   const isExternal = to && to.indexOf('http') !== -1 || to.indexOf('https') !== -1;

   const newTo = (pageContext && pageContext.lang !== lang.defaultLang ?  `/${pageContext.lang}` : "") + to;

  //console.log("AppLink to=",to,"newTo",newTo)
  return (
    <Link {...newProps} to={isExternal ? to : newTo} target={isExternal ? "_blank" : "_self"}/>
  )
})


AppLink.propTypes = {
  pageContext: PropTypes.object,
}

export {AppLink};
